export const MONTHS = [
  { label: 'Jan', value: 'jan' },
  { label: 'Fev', value: 'fev' },
  { label: 'Mar', value: 'mar' },
  { label: 'Abr', value: 'abr' },
  { label: 'Mai', value: 'mai' },
  { label: 'Jun', value: 'jun' },
  { label: 'Jul', value: 'jul' },
  { label: 'Ago', value: 'ago' },
  { label: 'Set', value: 'set' },
  { label: 'Out', value: 'out' },
  { label: 'Nov', value: 'nov' },
  { label: 'Dez', value: 'dez' }
]

export const MONTH_STRING_REGEX = /^(\d{2})\/(\d{4})$/
export const YEAR_MONTH_STRING_REGEX = /^(\d{4})-(\d{2})(?:-\d{2})?$/
export const NON_DIGIT_OR_SLASH_REGEX = /[^\d/]/
